import { React, UseState, UseEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PageContent from 'layouts/PageContent';
import ConstructConnect from './ConstructConnect';

const ConstructConnectScreen = (props) => {
  const {t, i18n} = useTranslation(['salesPerformance', 'common']);

  return (
    <PageContent title={t('salesPerformance:ConstructConnect')}>
      <ConstructConnect />
    </PageContent>
  )
}

export default ConstructConnectScreen;